var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"landing-page"},[_c('AuthHeaderV2Component'),_vm._t("default"),(['home','term_condition','overview'].includes(_vm.$route.name))?_c('AuthFooterV2Component'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }